import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const SelectorSize = (props) => {
    const { t } = useTranslation();
    return (React.createElement("label", { className: classNames('selector-size-item', props.disabled && 'disabled', props.selected && 'selected') },
        React.createElement("input", { type: "radio", checked: props.selected, onChange: props.onSelect, name: `size-selector-${props.variationGroupId}`, value: props.value, "aria-label": `${props.label}${(props.disabled && ' ' + t('label.outofstocksize') + ' ' + t('label.notifyme')) || ''}` }),
        React.createElement("span", { className: "selector-size-item__label", "aria-hidden": "true" }, props.label)));
};
export default SelectorSize;
